import '../assets/css/PageNotFound.css'
import '../assets/css/Common.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleXmark } from '@fortawesome/free-solid-svg-icons'
import { Helmet } from 'react-helmet'

function PageNotFound() {
    return (
        <div className='flex-container page-not-found-container'>
            <Helmet>
                <title>Stranica ne postoji</title>
                <meta
                    name="description"
                    content="Stranica ne postoji"
                    data-react-helmet="true" 
                />
            </Helmet>
            <div className='flex-container page-not-found-text-wrapper'>
                <FontAwesomeIcon icon={faCircleXmark} className='left-margin' fontSize={38}></FontAwesomeIcon>
                <p className='text-center'>Ova stranica ne postoji.</p>
                <a className='text-center' href='https://historiografija.ba'>Vratite se na početnu stranicu.</a>
            </div>
        </div>
    )
}

export default PageNotFound